AppTabs.createTab( {

name: 'enter-results',
icon: 'clipboard-check',
text: 'Enter Results',
//preload: 'vmEnterResults',
create: function(init) {
	'use strict'

	const fields = [
		{
			label: 		'Sample Number',
			columnName: 'SampleNumber',
			type:       'sample-link',
			order:		'asc',
		},
		{
			label: 		'Sample Description',
			columnName: 'SampleDescription',
			type:       'sample-link',
		},
		{
			label: 		'Test',
			columnName: 'TestID',
			isEditable:	true,
			type:		'test',
			render: 	DataTablesManager.getTestNameByID,
		},
		{
			label: 		'Analyte',
			columnName: 'Analyte',
		},
		{
			label: 		'Result',
			columnName: 'Result',
			isEditable:	true,
		},
		{
			label: 		'Units',
			columnName: 'Units',
			isEditable:	true,
			type:		'combobox',
			datalist:	'units'
		},
		{
			label: 		'QA Flag',
			columnName: 'QAFlag',
			isEditable:	true,
		},
		{
			label: 		'Analyzed Date',
			columnName: 'AnalyzedDate',
			isEditable:	true,
			type:       'date',
		},
		{
			label: 		'Analyzed Time',
			columnName: 'AnalyzedTime',
			isEditable: true,
		},
		{		
			label: 		'Dec Places',
			columnName: 'DecimalPlaces',
			isEditable:	true,
		},
		{
			label: 		'LOD',
			columnName: 'LOD',
			isEditable:	true,
		},
		{
			label: 		'LOQ',
			columnName: 'LOQ',
			isEditable:	true,
		},
		{
			label:		'Dilution',
			columnName: 'Dilution',
			isEditable:	true,
		},
		{
			label:		'Method',
			columnName: 'Method',
			isEditable:	true,
		},
		{
			label:		'Analyst',
			columnName: 'Analyst',
			isEditable:	true,
			postFilter: function( value ) {
				return value || tab.controller.initials;
			},
		},
		{
			label:		'Client Name',
			columnName: 'ClientName',
			type:       'client-link',
		},
		{
			label:		'DNR PAL',
			columnName: 'DNRPAL',
			isEditable:	true,
		},
		{
			label:		'DNR ES',
			columnName: 'DNRES',
			isEditable:	true,
		},
	];

	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#data-table-enter-results',

		// tables used by DataTables actions
		readTableName: 	'viewEnterResults',
		editTableName: 	'tblResults',

		primaryKey: 	'ResultID',

		hasColumnSearch: false,
		canSort:         true,
		drawWhen:        false,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable_enter_results',
		//actionAutofill:	'datatable_autofill_enter_results',
		//actionCreate:		'datatable_create_enter_results',
		actionEdit:			'datatable_edit_results',
		//actionRemove:		'datatable_remove_enter_results',

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			const vmEnterResults = tab.controller;
			data.testID 		= vmEnterResults.test 	? vmEnterResults.test.id 	: -1;
			data.sampleNumber 	= vmEnterResults.sampleNumber ? vmEnterResults.sampleNumber	: -1;
			data.hasResults 	= vmEnterResults.hasResults;
			console.log( { vmEnterResults, tab, data } );
			return data;
		},

		fields: fields,

	} );

	init.setController( new TabControllerVue({
		el: '#enter-results-datatable-filters',
		computed: {
			tests: function() {
				return LocalStorageManager.get( 'testList' );
			},
		},
		methods: {
			resetData() {
				this.hasResults    = 0;
				this.sampleNumber  = null;
				this.sampleNumbers = [];
				this.test          = null;
				this.initials      = null;
				this.fetchingSampleNumbers = false;
			},
			clear() {
				this.hasResults    = 0;
				this.sampleNumber  = null;
				this.test          = null;
			},
			onShowTab: function(){
				this.ajaxLoadSampleNumbers();
			},
			apply: function(){
				tab.drawTable();
			},
			ajaxLoadSampleNumbers: function() {
				const _this = this;
				_this.fetchingSampleNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_sample_numbers_by_client',
						clientId: this.client ? this.client.id : null,
					},
					onSuccess : function( response ) {
						_this.sampleNumbers = response.data;
					},
					onError : function( response ) {
						alert( _this.client
							? 'Could not load Sample Numbers for ' + _this.client.text
							: 'Could not load Sample Numbers' );
					},
					onComplete : function() {
						_this.fetchingSampleNumbers = false;
					},
				});
			},
		},
		watch: {}
	}) );
}

} );
